// Right now, the TikTok unique metrics are a subset 

const uniqueMetricsLookup = {
  reach: {
    key: 'reach',
    name: 'Reach',
    type: 'number',
    metric_direction: 'positive',
    description: 'The number of unique users who have seen your ad.',
    note: 'Only available in ad details drawer.'
  },
  frequency: {
    key: 'frequency',
    name: 'Frequency',
    type: 'number',
    metric_direction: 'positive',
    description: 'The average number of times a user has seen your ad.',
    note: 'Only available in ad details drawer.'
  },
  cpmr: {
    key: 'cpmr',
    name: 'CPMr',
    type: 'currency',
    metric_direction: 'negative',
    description: 'The cost per thousand unique impressions.',
    note: 'Only available in ad details drawer.'
  },
  unique_clicks: {
    key: 'unique_clicks',
    name: 'Unique Clicks',
    type: 'number',
    metric_direction: 'positive',
    description: 'The number of unique users who have clicked on your ad.',
    note: 'Only available in ad details drawer.'
  },
  unique_ctr: {
    key: 'unique_ctr',
    name: 'Unique CTR',
    type: 'percent',
    metric_direction: 'positive',
    description: 'The percentage of unique users who have clicked on your ad.',
    note: 'Only available in ad details drawer.'
  },
  unique_inline_link_clicks: {
    key: 'unique_inline_link_clicks',
    name: 'Unique Inline Link Clicks',
    type: 'number',
    metric_direction: 'positive',
    description: 'The number of unique users who have clicked on an inline link in your ad.',
    note: 'Only available in ad details drawer.'
  },
  unique_inline_link_click_ctr: {
    key: 'unique_inline_link_click_ctr',
    name: 'Unique Inline Link Click CTR',
    type: 'percent',
    metric_direction: 'positive',
    description: 'The percentage of unique users who have clicked on an inline link in your ad.',
    note: 'Only available in ad details drawer.'
  },
  unique_link_clicks_ctr: {
    key: 'unique_link_clicks_ctr',
    name: 'Unique Link Clicks CTR',
    type: 'percent',
    metric_direction: 'positive',
    description: 'The percentage of unique users who have clicked on a link in your ad.',
    note: 'Only available in ad details drawer.'
  },
  cost_per_unique_click: {
    key: 'cost_per_unique_click',
    name: 'Cost per Unique Click',
    type: 'currency',
    metric_direction: 'negative',
    description: 'The cost per unique click.',
    note: 'Only available in ad details drawer.'
  },
  cost_per_unique_inline_link_click: {
    key: 'cost_per_unique_inline_link_click',
    name: 'Cost per Unique Inline Link Click',
    type: 'currency',
    metric_direction: 'negative',
    description: 'The cost per unique inline link click.',
    note: 'Only available in ad details drawer.'
  },
  unique_link_clicks: {
    key: 'unique_link_clicks',
    name: 'Unique Link Clicks',
    type: 'number',
    metric_direction: 'positive',
    description: 'The number of unique users who have clicked on a link in your ad.',
    note: 'Only available in ad details drawer.'
  },
  unique_outbound_clicks_ctr: {
    key: 'unique_outbound_clicks_ctr',
    name: 'Unique Outbound CTR',
    type: 'percent',
    metric_direction: 'positive',
    description: 'The percentage of unique users who have clicked on a link in your ad.',
    note: 'Only available in ad details drawer.'
  }
}

// Return the keys for the unique metrics we will display in the UI (platform specific)
const getUniqueMetricDisplayKeys = (platform) => {
  if (platform === 'tiktok') {
    return [
      'reach',
      'frequency',
      'cpmr'
    ]
  } else if (platform === 'meta') {
    return [
      'reach',
      'frequency',
      'cpmr',
      'unique_outbound_clicks_ctr',
      'cost_per_unique_click',
      'unique_link_clicks'
    ]
  }
  // Fallback to all metrics
  return Object.keys(uniqueMetricsLookup)
}

export {
  uniqueMetricsLookup,
  getUniqueMetricDisplayKeys
}